import React, { useState } from 'react';
import { FileUploader } from '../common/FileUploader';
export function Product() {
  const [selectedCategory, setSelectedCategory] = useState('Product Details');
  const categories = ['Product Details', 'Policy Wordings', 'Underwriting Guidelines', 'Pricing Models', 'Claims Procedures', 'Risk Assessment Documents'];
  return <div className="bg-white rounded-lg shadow" data-id="element-420">
      <div className="p-6" data-id="element-421">
        <h2 className="text-xl font-semibold mb-6" data-id="element-422">Product Information</h2>
        <div className="grid grid-cols-1 gap-6 mb-6" data-id="element-423">
          <div className="bg-blue-50 p-6 rounded-lg" data-id="element-424">
            <h3 className="font-medium text-lg mb-4" data-id="element-425">Product Overview</h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-426">
              <div data-id="element-427">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-428">
                  Product Line
                </label>
                <select className="w-full p-2 border rounded-md" data-id="element-429">
                  <option data-id="element-430">Property</option>
                  <option data-id="element-431">Casualty</option>
                  <option data-id="element-432">Marine</option>
                  <option data-id="element-433">Motor</option>
                  <option data-id="element-434">Life</option>
                  <option data-id="element-435">Health</option>
                  <option data-id="element-436">Specialty</option>
                </select>
              </div>
              <div data-id="element-437">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-438">
                  Target Market
                </label>
                <input type="text" className="w-full p-2 border rounded-md" placeholder="e.g. Small Business Owners" data-id="element-439" />
              </div>
              <div data-id="element-440">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-441">
                  Geographic Coverage
                </label>
                <input type="text" className="w-full p-2 border rounded-md" placeholder="e.g. United Kingdom" data-id="element-442" />
              </div>
              <div data-id="element-443">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-444">
                  Average Premium (£)
                </label>
                <input type="text" className="w-full p-2 border rounded-md" placeholder="e.g. 1,500" data-id="element-445" />
              </div>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-446">
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-447">
            <h3 className="font-medium text-lg mb-4" data-id="element-448">Product Documents</h3>
            <div className="mb-4" data-id="element-449">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-450">
                Document Category
              </label>
              <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="w-full p-2 border rounded-md" data-id="element-451">
                {categories.map(category => <option key={category} value={category} data-id="element-452">
                    {category}
                  </option>)}
              </select>
            </div>
            <FileUploader data-id="element-453" />
            <div className="mt-6 text-sm text-gray-500" data-id="element-454">
              <p data-id="element-455">Acceptable document formats: PDF, DOC, DOCX, XLS, XLSX</p>
              <p data-id="element-456">Maximum file size: 10MB</p>
            </div>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-457">
            <h3 className="font-medium text-lg mb-4" data-id="element-458">Document Requirements</h3>
            <div className="space-y-4" data-id="element-459">
              <div data-id="element-460">
                <h4 className="font-medium" data-id="element-461">Product Details</h4>
                <p className="text-sm text-gray-600" data-id="element-462">
                  Detailed description of insurance products including coverage,
                  limits, and exclusions.
                </p>
              </div>
              <div data-id="element-463">
                <h4 className="font-medium" data-id="element-464">Policy Wordings</h4>
                <p className="text-sm text-gray-600" data-id="element-465">
                  Sample policy documents and terms & conditions for each
                  product.
                </p>
              </div>
              <div data-id="element-466">
                <h4 className="font-medium" data-id="element-467">Underwriting Guidelines</h4>
                <p className="text-sm text-gray-600" data-id="element-468">
                  Criteria and procedures used to evaluate and price risks.
                </p>
              </div>
              <div data-id="element-469">
                <h4 className="font-medium" data-id="element-470">Pricing Models</h4>
                <p className="text-sm text-gray-600" data-id="element-471">
                  Documentation on how premiums are calculated and risk factors
                  considered.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}